import script from "./HeaderTypeC.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderTypeC.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderTypeC.vue?vue&type=style&index=0&id=1857ccb0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1857ccb0"]])

export default __exports__